import { Pipe, PipeTransform } from '@angular/core';
import { ContractRenewType } from '../../interfaces/contract';

@Pipe({
  name: 'contractRenewType'
})
export class ContractRenewTypePipe implements PipeTransform {

  transform(value: ContractRenewType): string {
    const types = {
      [ContractRenewType.INDEFINITE_DURATION]: 'Indefinido',
      [ContractRenewType.AUTOMATIC_RENEWAL]: 'Automático',
      [ContractRenewType.RENEWAL_OPTION]: 'Opcional',
      [ContractRenewType.FIXED_TERM]: 'Fixo'
    }

    return types[value]
  }

}
